import { memo } from "react";

const PermitFooter = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <p className="text-center text-red-600 text-xs ">
        Classification: Confidential External 
        {/* | سري خارجي */}
      </p>
    </div>
  );
};

export default memo(PermitFooter);
